import React from 'react';

type RecruiterTool = {
  _id: string;
  name: string;
  faviconUrl?: string;
  url: string;
};

type UserRecruiterToolsListProps = {
  tools: RecruiterTool[];
  maxItems?: number;
  size?: 'sm' | 'md' | 'lg';
  showNames?: boolean;
  className?: string;
};

const UserRecruiterToolsList: React.FC<UserRecruiterToolsListProps> = ({
  tools = [],
  maxItems = 100,
  size = 'sm',
  showNames = false,
  className = '',
}) => {
  if (!tools || tools.length === 0) {
    return null;
  }

  const displayedTools = tools.slice(0, maxItems);
  const remainingCount = tools.length - maxItems;

  const sizeClasses = {
    sm: { img: 'w-4 h-4', text: 'text-xs', gap: 'gap-1' },
    md: { img: 'w-5 h-5', text: 'text-sm', gap: 'gap-1.5' },
    lg: { img: 'w-6 h-6', text: 'text-base', gap: 'gap-2' },
  };

  const { img: imgClass, text: textClass, gap: gapClass } = sizeClasses[size];

  return (
    <div className={`flex items-center flex-wrap ${gapClass} ${className}`}>
      {displayedTools.map((tool) => (
        <div key={tool._id} className={`flex items-center ${gapClass}`} title={tool.name}>
          {tool.faviconUrl ? (
            <img
              src={tool.faviconUrl}
              alt={tool.name}
              className={`${imgClass} rounded-sm flex-shrink-0`}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                // Show fallback next element if needed
                const fallback = target.nextElementSibling as HTMLElement;
                if (fallback) fallback.style.display = 'flex';
              }}
            />
          ) : null}
          <div
            className={`${imgClass} bg-gray-200 rounded-sm flex items-center justify-center flex-shrink-0 ${tool.faviconUrl ? 'hidden' : ''}`}
            style={{ display: tool.faviconUrl ? 'none' : 'flex' }}
          >
            <span className="text-gray-500 font-mono" style={{ fontSize: '8px' }}>
              ?
            </span>
          </div>
          {showNames && <span className={`${textClass} truncate max-w-20`}>{tool.name}</span>}
        </div>
      ))}
      {remainingCount > 0 && <span className={`${textClass} text-gray-500 font-medium`}>+{remainingCount}</span>}
    </div>
  );
};

export default UserRecruiterToolsList;
